module.exports = __webpack_public_path__ + "img/yiwancheng.b7e660ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/process/yiwancheng.png
// module id = 518
// module chunks = 137